/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "aHbe1_ytUI",
    title: "ON Whey Protein Powder",
    ratings: "4.5",
    price: "6,999",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/whey-protein/ON-Whey-Protein-5-lb.webp",
    imgAlt: "ON-Whey-Protein-5-lb",
    categoryName: "protein",
  },
  {
    _id: "aHbe2_ytUI",
    title: "Dymatize Whey Protein",
    ratings: "4.8",
    price: "7,999",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/whey-protein/dymatize-whey-protein.webp",
    imgAlt: "dymatize-whey-protein",
    categoryName: "protein",
  },
  {
    _id: "aHbe3_ytUI",
    title: "Dymatize creatine monohydrate",
    ratings: "4.2",
    price: "1,999",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/creatine/dymatize-creatine.webp",
    imgAlt: "dymatize-creatine",
    categoryName: "creatine",
  },
  {
    _id: "aHbe4_ytUI",
    title: "MuscleBlaze Super Gainer XXL Weight Gainer",
    ratings: "3.3",
    price: "4,299",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/gainer/mb-gainer.webp",
    imgAlt: "mb-gainer",
    categoryName: "gainer",
  },

  {
    _id: "aHbe5_ytUI",
    title: "Nutrilite Multivitamin",
    ratings: "3.6",
    price: "2,399",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/multi-vitamins/amway-muti-vit.jpeg",
    imgAlt: "amway-muti-vit",
    categoryName: "multivitamin",
  },
  {
    _id: "aHbe6_ytUI",
    title: "MuscleBlaze Omega 3 Fish Oil Gold",
    ratings: "4.7",
    price: "999",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/multi-vitamins/mb-fish-oil.webp",
    imgAlt: "mb-fish-oil",
    categoryName: "multivitamin",
  },
  {
    _id: "aHbe7_ytUI",
    title: "Dymatize mass gainer",
    ratings: "2.9",
    price: "999",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/gainer/dymatize-gainer.webp",
    imgAlt: "dymatize-gainer",
    categoryName: "gainer",
  },
  {
    _id: "aHbe8_ytUI",
    title: "Myprotein Whey Protein",
    ratings: "4.5",
    price: "6,599",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/whey-protein/myprotein-whey-protein.webp",
    imgAlt: "myprotein-whey-protein",
    categoryName: "protein",
  },
  {
    _id: "aHbe9_ytUI",
    title: "MuscleBlaze creatine monohydrate",
    ratings: "4.4",
    price: "499",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/creatine/mb-creatine.webp",
    imgAlt: "mb-creatine",
    categoryName: "creatine",
  },
  {
    _id: "aHbe10_ytUI",
    title: "MuscleTech MassTech Extreme",
    ratings: "1.9",
    price: "4,699",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/gainer/muscletech-gainer.webp",
    imgAlt: "muscletech-gainer",
    categoryName: "gainer",
  },
  {
    _id: "aHbe11_ytUI",
    title: "ON Serious Mass Weight Gainer",
    ratings: "3.9",
    price: "1,699",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/gainer/on-gainer.webp",
    imgAlt: "on-gainer",
    categoryName: "gainer",
  },
  {
    _id: "aHbe12_ytUI",
    title: "GNC Mega Men Multivitamin",
    ratings: "2.5",
    price: "2,399",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/multi-vitamins/gnc-mega-men.webp",
    imgAlt: "gnc-mega-men",
    categoryName: "multivitamin",
  },
  {
    _id: "aHbe13_ytUI",
    title: "ON creatine monohydrate",
    ratings: "4.2",
    price: "999",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/creatine/on-creatine.webp",
    imgAlt: "on-creatine",
    categoryName: "creatine",
  },
  {
    _id: "aHbe14_ytUI",
    title: "Muscletech Whey Protein",
    ratings: "3.8",
    price: "5,999",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/whey-protein/muscletech-whey-protein.jpeg",
    imgAlt: "muscletech-whey-protein",
    categoryName: "protein",
  },
  {
    _id: "aHbe15_ytUI",
    title: "GNC Pro creatine monohydrate",
    ratings: "1.9",
    price: "1,299",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/creatine/gnc-creatine.webp",
    imgAlt: "gnc-creatine",
    categoryName: "creatine",
  },
  {
    _id: "aHbe16_ytUI",
    title: "MuscleBlaze MB-VITE Multivitamin",
    ratings: "4.1",
    price: "1,199",
    imgSrc:
      "https://fitmart-screens.netlify.app/assets/products/multi-vitamins/mb-multi-vit.webp",
    imgAlt: "mb-multi-vit",
    categoryName: "multivitamin",
  },
];
